/* eslint-disable no-var */
/* eslint-disable no-unused-vars */



( function( $ ) {
	var cstart, cend;
	var stab = 'settings';
	var hash = document.location.hash.replace( '#', '' );

	var isEmail = function(email) {
		var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
		return regex.test(email);
	}

	$( window ).on( 'hashchange', function( ) {
		hash = document.location.hash.replace( '#', '' );
		famneShowTab( hash );
	});

	if ( document.cookie.length > 0 ) {
		cstart = document.cookie.indexOf( 'famnetab=' );
		if ( cstart !== -1 ) {
			cstart = cstart + 9;
			cend = document.cookie.indexOf( ';', cstart );
			if ( cend === -1 ) {
				cend = document.cookie.length;
			}
			stab = unescape( document.cookie.substring( cstart, cend ) );
		}
	}


	if ( hash !== '' ) {
		stab = hash;
	}


	function famneShowTab( tab ) {
		$( '.sections-container' ).addClass( 'hidden' );
		$( '#sections-' + tab ).removeClass( 'hidden' );
		$( '.nav-tab-wrapper>a' ).removeClass( 'nav-tab-active' );
		$( '.nav-tab-wrapper>a#tab-' + tab ).addClass( 'nav-tab-active' );
		document.location = '#' + tab;
	}


	$( '.sections-container' ).each( function( ) {
		var slug = $( this ).attr( 'id' ).replace( 'sections-', '' );
		var title = $( this ).attr( 'title' );
		var icon = $( this ).attr( 'data-icon' );
		var iconhtml = icon !== '' ? '<span class="dashicons-before ' + icon + '"></span>' : '';

		var $tab = $( '<a id="tab-' + slug + '" class="nav-tab">' + iconhtml + title + '</a>' );
		$tab.on( 'click', function() {
			document.cookie = 'famnetab=' + slug;
			famneShowTab( slug );
		});
		$( '.nav-tab-wrapper' ).append( $tab );
	});

	famneShowTab( stab );

	$('input[name="famne_options[custom_admin_recipients]"]').on('change',function(){
		var $card = $(this).closest('.card');
		var value = $(this).val();
		$(this).closest('.text-container').removeClass('error');

		if ($(this).val() === '')
		{
			$('.switch .slider',$card).removeClass('active');
			return ;
		}else{
			$('.switch .slider',$card).addClass('active');
		}

		var emails = value.split(',');
		for (var i in emails)
		{
			if (!isEmail(emails[i].replace(' ','')))
			{
				$(this).closest('.text-container').addClass('error');
			}
		}
	});


	$('.checkbox-change').on('change',function(){
		var $el = $(this).closest('.option-container');
		var $card = $(this).closest('.card');
		$(this).is(':checked')?$el.addClass('active'):$el.removeClass('active');
		if ($('.option-container.active',$card).length === 0)
		{
			$('.switch .slider',$card).removeClass('active');
		}else{
			$('.switch .slider',$card).addClass('active');
		}
	});

	$('input[type=\'file\']#settings-upload-file').on('change',function(){
		var message = $(this).attr('data-message');
		$('#settings-upload-submit').removeAttr('disabled').on('click',function(){
			return confirm(message);
		});
	});

}( jQuery ) );

